export type Stat = { label: string; count: number };
export type Stats = Stat[];

export type StatRaw = { label: string; count: string };
export type StatsRaw = StatRaw[];

export enum GroupBy {
  Experience = 'experience',
  AgeCategory = 'age-category',
  City = 'city',
  Status = 'status',
}

export interface StatGroupBy {
  label1: string;
  label2?: string;
  count: number;
}

export interface StatGroupByRaw {
  label1: string;
  label2?: string;
  count: string;
}
